<template>
    <TableRow
        
    >
        <TableCell>
            <div
                class="flex justify-start items-center p-2 pl-4 w-[4.5rem]"
            >
                <div class="whitespace-nowrap flex justify-start items-center w-full">
                    {{ researchAssignment.id }}
                </div>
            </div>

        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2">
                {{ researchAssignment.assignment_name }}
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2">
                {{ researchPage }}
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2">
                <base-dblclick-select
                    modelType="researchAssignment"
                    :model-id="researchAssignment.id"
                    field-name="user_id"
                    :field-options="userOptions"
                    :field-value="researchAssignment.user ? researchAssignment.user.id : null"
                    :displayed-field-value="researchAssignment.user ? `${researchAssignment.user.first_name} ${researchAssignment.user.last_name}` : null"
                    :field-style="cellDisplayStyle"
                    inputType="number"
                    @refetch="refetchResults"
                    class="w-full"
                ></base-dblclick-select>
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2">
                {{ assignedAt }}
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2">
                {{ status }}
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2 text-right">
                {{ initialCompanyCount}}
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2 text-right">
                {{ companiesWorked }}
            </div>
        </TableCell>
        <TableCell >
            <div class="whitespace-nowrap w-full p-2 text-right">
                {{ companiesToBeWorked }}
            </div>
        </TableCell>
    </TableRow>
</template>

<script setup>
import {ref, defineProps, defineEmits, computed, watch } from "vue";
import TableRow from '@/components/base-components/TableRow.vue';
import TableCell from '@/components/base-components/TableCell.vue';
import { formatDateWithMinutes } from "@/composables/formatDate";
import { formatNumbersWithCommas } from "@/composables/FormatNumbers";

const props = defineProps([
    'researchAssignment',
    'selectAll',
    'isLoading',
    'userOptions'
])

const emit = defineEmits([
    'refetch-results', 
    'loading'
])

function refetchResults() {
    emit('refetch-results')
}


const isSelected = ref(props.selectAll)
const cellDisplayStyle = ref('padding:0.5rem;')


const user = computed(() => {
    if(props.researchAssignment.user) {
        return `${props.researchAssignment.user.first_name} ${props.researchAssignment.user.last_name}`
    } else {
        return '--'
    }
})

const researchPage = computed(() => {
    if(props.researchAssignment){
        if(props.researchAssignment.research_page === 'vet_urls'){
            return "Vet URLs"
        } else if (props.researchAssignment.research_page === 'missing_url_or_zoom_info_companies'){
            return "Missing URLs or ZoomInfo Companies"
        }
    }
    return '--'
})

const assignedAt = computed(() => {
    if(props.researchAssignment.assigned_at) {
        return formatDateWithMinutes(props.researchAssignment.assigned_at)
    } else {
        return '--'
    }
})

const status = computed(() => {
    return props.researchAssignment ? props.researchAssignment.status : '--'
})

const initialCompanyCount = computed(() => {
    return props.researchAssignment ? formatNumbersWithCommas(props.researchAssignment.initial_company_count) : '--'
})

const companiesWorked = computed(() => {
    return props.researchAssignment ? formatNumbersWithCommas(props.researchAssignment.companies_worked) : '--'
})

const companiesToBeWorked = computed(() => {
    return props.researchAssignment ? formatNumbersWithCommas(props.researchAssignment.companies_to_be_worked) : '--'
})


</script>